(() => {
  const headingSelectors = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    '[role="heading"]',
  ];

  window.swinger.observer.initialize('dialog:not([aria-labelledby]),[role="dialog"]:not([aria-labelledby])', (elem) => {
    const uuid = Date.now();
    const id = `swinger-dialog-label-${uuid}`;
    let labelElem = elem.querySelector(headingSelectors.join(','));

    if (!labelElem) {
      labelElem = window.swinger.$('*', elem).find((elem) => !elem.childElementCount && elem.textContent.trim());
    }

    if (!labelElem) {
      return;
    }

    document.querySelectorAll(`#${id}`).forEach((elem) => {
      elem.removeAttribute('id');
    });
    labelElem.setAttribute('id', id);
    elem.setAttribute('aria-labelledby', id);
  }, false);

  // Safeguards against a head/foot JS mismatch
  if (!window.swinger.focusableElements) {
    return;
  }

  const focusableElementsSelector = window.swinger.focusableElements.map((selector) => `dialog ${selector}`).join(',');
  window.swinger.observer.initialize(focusableElementsSelector, (elem) => {
    const dialog = elem.closest('dialog');
    const firstFocusableElementInDialog = dialog.querySelector(focusableElementsSelector);

    if (firstFocusableElementInDialog && elem === firstFocusableElementInDialog) {
      const inputMode = elem.getAttribute('inputmode');

      if (inputMode) {
        elem.setAttribute('data-inputmode', inputMode);
      }

      elem.setAttribute('inputmode', 'none');
    }
  }, false);

  window.swinger.eventHub.register('click', '[inputmode="none"]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const inputMode = elem.getAttribute('data-inputmode');

    if (inputMode) {
      elem.setAttribute('inputmode', inputMode);
    } else {
      elem.removeAttribute('inputmode');
    }
  });
})();
